import * as z from "zod";

export const getSandboxLoginConfig = {
  name: "getSandboxLoginConfig" as const,
  input: z.null(),
  output: z.object({
    enabled: z.boolean(),
    emails: z.array(z.string()),
    teamId: z.string().nullable(),
  }),
};
